import type { FC, ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import type { Props } from "react-intl/src/components/message.js";

import type messages from "./en-US.js";

/*
 Wrappers around react-intl components and functions, so that we can correctly type check the id
 */

export interface SelMessageProps extends Props<Record<string, ReactNode>> {
  id: keyof typeof messages;
  values?: Record<string, ReactNode>;
}

export const SelMessage: FC<SelMessageProps> = (props) => {
  const values = props.values ? { ...msgFormatting, ...props.values } : msgFormatting;
  return <FormattedMessage id={props.id} values={values} />;
};

const msgFormatting = {
  emph: ([chunk, ..._otherChunks]) => {
    return <strong>{chunk}</strong>;
  },
};
